module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "phone-preview"
  }, [_c('section', {
    staticClass: "phone-preview-buttons"
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.url) ? _c('div', {
    staticClass: "phone-preview-wrapper"
  }, [_c('div', {
    staticClass: "phone-preview-window"
  }, [_c('div', {
    staticClass: "phone-preview-content"
  }, [_c('iframe', {
    attrs: {
      "src": _vm.url,
      "frameborder": "0",
      "width": "100%",
      "height": "100%"
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e5d0f76","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/preview.vue
// module id = 572
// module chunks = 0